module.exports = __webpack_public_path__ + "static/img/loginTop.c65acac.png";


//////////////////
// WEBPACK FOOTER
// ./static/loginTop.png
// module id = Mdvw
// module chunks = 1